import Container from '@material-ui/core/Container';
import Header from './Components/Header';
import SiteContainer from './Containers/SiteContainer';
import './App.css';

function App() {
  return (
    <Container maxWidth='false'>
    <div className='app'>
      <Header />
      <SiteContainer />
    </div>
    </Container>
  );
}

export default App;